<template>
  <bb-modal
    :visible="showModal"
    flavor="user"
    @close="close"
  >
    <p class="small m-10">
      {{ description }}
    </p>
    <div class="d-flex">
      <bb-button
        color="mint"
        class="m-l-5 m-r-5 m-t-15 flex-1"
        :label="positiveButtonText"
        @click="yesPressed"
      />
      <bb-button
        v-if="allowRoutingToFirstPage"
        color="red"
        class="m-l-5 m-r-5 m-t-15 flex-1"
        :label="negativeButtonText"
        @click="noPressed"
      />
    </div>
  </bb-modal>
</template>

<script>
  import { BbModal, BbButton } from '@bigbank/interface-components';

  export default {
    name: 'back-navigation-modal',

    components: {
      BbButton,
      BbModal,
    },

    props: {
      description: {
        type: String,
        required: true,
      },
      positiveButtonText: {
        type: String,
        required: true,
      },
      negativeButtonText: { type: String },
      allowRoutingToFirstPage: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        showModal: false,
        resolve: null,
      };
    },

    beforeMount() {
      let previousRoute;

      this.$router.beforeEach((toRoute, fromRoute, next) => {
        if (this.isNewRoute(previousRoute, toRoute) || toRoute.params.ignoreBackNavigationProtection) {
          previousRoute = fromRoute;
          next();
        } else {
          this.show()
            .then(confirm => {
              next(confirm);
              if (confirm) {
                if (toRoute.fullPath !== '/') {
                  this.$router.push('/');
                }
                window.location.reload();
                previousRoute = null;
              }
            });
        }
      });
    },

    methods: {
      show() {
        this.showModal = true;

        return new Promise(resolve => {
          this.resolve = resolve;
        });
      },
      close() {
        this.showModal = false;
        this.resolve(false);
      },
      yesPressed() {
        this.showModal = false;

        if (this.allowRoutingToFirstPage) {
          this.resolve(true);
        } else {
          this.resolve(false);
        }
      },
      noPressed() {
        this.showModal = false;
        this.resolve(false);
      },
      isNewRoute(previousRoute, toRoute) {
        return !(previousRoute &&
          previousRoute.fullPath === toRoute.fullPath &&
          previousRoute.name === toRoute.name);
      },
    },
  };

</script>
